import { FormEvent, useState } from "react";
import { useAdmin } from "../../../context/admin";
import AdminService from "../../../services/admin.service";
import Calendar from "../../common/Calendar";
import GeneralInput from "../../common/GeneralInput";
import Modal from "../../common/Modal";
import { AiFillCloseCircle } from "react-icons/ai";

export default function EditDailyCost() {
    const { editDailyCostData, setEditDailyCostData } = useAdmin()
    const [date, setDate] = useState<Date>(editDailyCostData ? new Date(editDailyCostData.incurred_at) : new Date())
    const [data, setData] = useState({
        name: editDailyCostData?.name || '',
        amount: editDailyCostData?.amount || 0
    })
    async function handleSaveChanges(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        try {
            const formattedData = {
                amount: data?.amount,
                name: data?.name,
                incurred_at: date
            }
            const response = await AdminService.editDailyCost(editDailyCostData!.id, formattedData)
            window.location.reload()
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <Modal
        onSubmit={handleSaveChanges}
        >
            <h1>
                Edit Daily Cost
            </h1>
            <Calendar 
            selectedDay={date}
            selectPastDays
            setSelectedDay={setDate}
            />
            <GeneralInput
            name="name"
            label="Name"
            type="text"
            value={data.name || ''}
            onChange={(e) => setData({...data, name: e.target.value})}
            style={{margin: '10px 0'}}
            />
            <GeneralInput
            name="amount"
            label="Amount"
            type="number"
            style={{marginBottom: '10px'}}
            value={data.amount || ''}
            onChange={(e) => setData({...data, amount: Number(e.target.value)})}
            />
            <div className="actions">
                <button 
                >
                    Edit
                </button>
            </div>
            <div className="close"
            onClick={() => setEditDailyCostData(undefined)}
            >
                <AiFillCloseCircle/>
            </div>
        </Modal>
    )
}